import React from "react";
import {
  FaFacebookF,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaBook,
} from "react-icons/fa";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container footer-grid">
  
          <div className="footer-col">
            <h5>| Teléfonos</h5>
            <ul>
              <li>
                <FaPhoneAlt /> Mesa de Partes: <strong>287-1526</strong>
              </li>
              <li>
                <FaPhoneAlt /> Informes: <strong>992-038-334</strong>
              </li>
            </ul>
          </div>

     
          <div className="footer-col">
            <h5>| Redes Sociales</h5>
            <ul>
              <li>
                <a
                  href="https://www.facebook.com/IESTPGILDABALLIVIANOFICIAL"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaFacebookF /> Facebook
                </a>
              </li>
              <li>
                <a
                  href="#"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaBook /> Libro de Reclamaciones
                </a>
              </li>
            </ul>
          </div>

    
          <div className="footer-col">
            <h5>| Correos</h5>
            <ul>
              <li>
                <FaEnvelope /> soporte@iestpgildaballivian.edu.pe
              </li>
              <li>
                <FaEnvelope /> mesadepartes@iestpgildaballivian.edu.pe
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h5>| Dirección</h5>
            <ul>
              <li>
                Instituto de Excelencia de Lima - Perú
              </li>
              <li>
                <FaMapMarkerAlt /> Av. Vargas Machuca N° 315<br />
                (Frente al Banco de Crédito)<br />
                San Juan de Miraflores – Lima – Perú
              </li>
            </ul>
          </div>
        </div>
      </div>


      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} IESTP Gilda Liliana Ballivián Rosado — 
          Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
}
